import Grid from '@/global/components/ui/Grid'
import { FormField, FormFieldSelect } from 'global/components/Form'
import opcoesDiasDSR from '../constants/opcoes-dia-dsr'

export default function CabecalhoTabelaHorarioForm() {
    return (
        <Grid container spacing={2}>
            <Grid item xs={3}>
                <FormField
                    name="codigo"
                    label="Código"
                    placeholder="(gerar automaticamente)"
                    type="number"
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>
            <Grid item xs={6}>
                <FormField
                    name="nome"
                    label="Nome da tabela"
                    required
                    autoComplete="off"
                />
            </Grid>
            <Grid item xs={3}>
                <FormFieldSelect
                    label="Dia do DSR"
                    name="diaDescontoDSR"
                    options={opcoesDiasDSR()}
                    defaultValue="-1"
                />
            </Grid>
        </Grid>
    )
}
